export default __webpack_public_path__ + "static/media/IN2_altia_blanc.02151682.png";